export default{
  key: "service_plan",
  fields: [
    { key: "plan_id" },
    { key: "name" },
  ]
}